export enum OrgTreeFilterType {
  NoFilters = 'NoFilters',
  NoLineManager = 'NoLineManager',
  MultipleLineManager = 'MultipleLineManager',
  Authorized = 'Authorized'
}
